import React from 'react';
import { DropdownButton, Dropdown, Pagination } from 'react-bootstrap';

const TablePagination = ({
  rowsPerPage,
  handleRowsPerPageChange,
  pagination,
  totalPages,
  handlePreviousPage,
  handleNextPage,
  totalUsers,  
}) => {

  return (
    <div className="d-flex justify-content-between  align-items-center">
      <div className="el-page-count">
    
        <DropdownButton
          variant="link"
          id="dropdown-basic-button"
          title={rowsPerPage === totalUsers ? 'Show All' :  `Show ${rowsPerPage} Entries` } // Show 'View all' when it matches totalUsers
          onSelect={handleRowsPerPageChange}
        >
          <Dropdown.Item eventKey="10">Show 10 entries</Dropdown.Item>
          <Dropdown.Item eventKey="20">Show 20 entries</Dropdown.Item>
          <Dropdown.Item eventKey="30">Show 30 entries</Dropdown.Item>
          <Dropdown.Item eventKey="40">Show 40 entries</Dropdown.Item>
          <Dropdown.Item eventKey="50">Show 50 entries</Dropdown.Item>
          <Dropdown.Item eventKey="Show All">Show All</Dropdown.Item>
        </DropdownButton>
      </div>
      <div>
      {/* {pagination.page}<br/>
      {totalPages}<br/>
      {totalUsers} */}
        <Pagination className='mb-0'>
        {/* typeof totalUsers !== undefined || */}
          <Pagination.Prev className='backbtnarrow' onClick={handlePreviousPage} disabled={pagination.page === 1 || ( totalUsers === 0)} />
          <Pagination.Item>{pagination.page}</Pagination.Item>
          {/* typeof totalUsers !== undefined || */}
          <Pagination.Next className='nexttnarrow'  onClick={handleNextPage} disabled={pagination.page === totalPages || ( totalUsers === 0)} />
        </Pagination>
      </div>
    </div>
  );
};

export default TablePagination;
